import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import { ConfirmDialogComponent } from 'src/app/shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import constants from 'src/constant.json';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';
import { CreateMortgageDialogComponent } from '../create-mortgage-dialog/create-mortgage-dialog.component';
import { CreateMyHomeDialogueComponent } from '../create-my-home-dialogue/create-my-home-dialogue.component';

interface address {
  streetAddress: string;
  fullAddress: string;
  city: string;
  state: string;
  zip: string;
  propertySubType: string;
  bedCount: number;
  bathCount: number;
  livingAreaSize: number;
  lotSize: number;
  coordinate: Object;
  PMXPropertyId: number | string;
  id: string;
  streetName: string;
  streetNumber: string;
  propertyType: string;
  purchaseDate: string;
}

@Component({
  selector: 'app-financing',
  templateUrl: './financing.component.html',
  styleUrls: ['./financing.component.scss'],
})
export class FinancingComponent implements OnInit, OnDestroy {
  @ViewChild('mortgageSectionToScroll') mortgageSectionToScroll: ElementRef;
  @Input() address;
  @ViewChild('equitySectionToScroll') equitySectionToScroll: ElementRef;
  @Output() purchaseValueEvent = new EventEmitter<number>();
  @ViewChild('purchaseValuePopover') purchaseValuePopover: NgbPopover;
  @Input() currentValue: number;
  @Input() propmixValue: number;
  @Input() loanBalance: number;
  @Input() netEquity: number;
  @Input() appreciateRatio: number;
  @Input() purchaseValue: number;
  onDestroyNotifier$ = new Subject();
  isEquityAnalysis: boolean = false;
  source: string;
  constructor(
    private myHomeService: MyHomeService,
    public myHomeState: MyHomeState,
    private dialog: MatDialog,
    private subscriptionService: SubscriptionPlanService,
    private formBuilder: FormBuilder,
    private activityLoggerService: ActivityLoggerService,
    private router: Router
  ) { }

  // @HostListener('window:beforeunload', ['$event'])
  // verifyState($event) {
  //   // if(this.hasChanges)
  //   $event.returnValue = 'Your data will be lost! Please save before you leave.';
  // }

  spendForecastForm = this.formBuilder.group({
    customCurrentValue: new FormControl(null),
    customPropmixValue: new FormControl(null),
    customPurchaseValue: new FormControl(null),
  });
  pmxPropertyId: any;
  loggerAddress: any;
  homeList = [];
  mortgageArray: any;
  selectedPmxId;
  activeHome$;
  activeHome;
  isLoading = false;
  spendForecastSheetActive: boolean = false;
  selectedRouteId: string;
  selectedHomeValue: any;
  activePropertyDetails: any = {};
  propertyAddedParams: any;
  soldDate;
  // Subject used to unsubscribe all Subscriptions on OnDestroy
  private onDestroyNotifier: Subject<any> = new Subject<any>();

  ngOnInit() {
    const path = this.router.url.split('?')[0];
    if (path?.includes('equity-analysis')) {
      this.isEquityAnalysis = true;
      this.source = 'fromEquiltyAnalysis';
    }
    this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((mortgageHistory) => {
      if (mortgageHistory) {
        this.mortgageArray = [].concat(mortgageHistory);
        this.mortgageArray.forEach((mortgage) => {
          if (!mortgage.refinanceScenarioList) {
            let params = {
              interestRate: this.mortgageArray[0].interest,
              termBalance: 180,
              closingCost: 0,
              isActive: false,
              id: 1,
              name: 'New Loan Scenario 1',
            };
            mortgage.refinanceScenarioList = [params];
          }
        });
      }

    });

    // this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((res) => {
    //   this.getHomeList();
    // });
    // this.activatedRoute.queryParams.pipe().subscribe((res) => {
    //   if (res.street && res.city) {
    //     this.propertyAddedParams = res.city || res.state;
    //     this.selectedRouteId = null;
    //   }
    //   if (res.id) {
    //     this.selectedRouteId = res.id;
    //     this.propertyAddedParams = null;
    //   }
    // });

    this.myHomeState.activePropertyDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && res.basic) {
        this.soldDate = res.basic.Lst_CloseDate;
        this.pmxPropertyId = res.basic.PMXPropertyId;

        this.loggerAddress = {
          city: res.basic.City,
          state: res.basic.StateOrProvince,
          street: res.basic.StreetAddress,
          zip: res.basic.PostalCode,
        };
      }
    });

    // this.myHomeState.myHomeList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((homeList) => {
    //   if (!homeList || !homeList.length) return;
    //   if (!this.selectedRouteId && this.selectedRouteId != 'undefined' && this.propertyAddedParams == null) {
    //     this.router.navigate(['/my-property'], {
    //       relativeTo: this.activatedRoute,
    //       queryParams: {
    //         id: homeList[0].id,
    //       },
    //       queryParamsHandling: 'merge',
    //     });
    //     this.selectedRouteId = homeList[0].id;
    //   }
    //   if (this.propertyAddedParams) this.selectedRouteId = homeList[0].id;
    //   this.selectedHomeValue = homeList.find((selectedHome) => selectedHome.id == this.selectedRouteId);
    //   this.homeList = homeList;
    //   if (this.myHomeState.activeHomeValue && !this.myHomeState.activeHomeValue.id) {
    //     this.myHomeState.mortgageListValue = this.selectedHomeValue?.mortgageList
    //       ? this.selectedHomeValue.mortgageList
    //       : [];
    //     this.myHomeState.activeHomeValue = this.selectedHomeValue;
    //     // this.myHomeService.setActiveHome(this.homeList[0]);
    //   } else {
    //     let home = this.homeList.find((home) => home.PMXPropertyId == this.myHomeState.activeHomeValue.PMXPropertyId);
    //     if (home) {
    //       this.myHomeState.mortgageListValue = home.mortgageList;
    //       this.myHomeState.activeHomeValue = home;
    //       // this.myHomeService.setActiveHome(home);
    //     }
    //   }
    //   // this.activeHomeChanged();
    // });
    // this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((mortgageHistory) => {
    //   this.mortgageArray = [].concat(mortgageHistory);
    //   this.mortgageArray.forEach((mortgage) => {
    //     if (!mortgage.refinanceScenarioList) {
    //       let params = {
    //         interestRate: this.mortgageArray[0].interest,
    //         termBalance: 180,
    //         closingCost: 0,
    //         isActive: false,
    //         id: 1,
    //         name: 'New Loan Scenario 1',
    //       };
    //       mortgage.refinanceScenarioList = [params];
    //     }
    //     console.log(this.mortgageArray, 'mortgageArray');
    //   });
    //   let loanAmount = 0;
    //   if (mortgageHistory && mortgageHistory.length) {
    //     mortgageHistory.map((element) => {
    //       element.PMXPropertyId = this.myHomeState.activeHomeValue.PMXPropertyId;
    //       let computedLoan = this.loanService.computeTotalLoan(
    //         element.principal,
    //         element.interest / 100,
    //         element.term,
    //         new Date(element.startDate)
    //       );

    //       if (computedLoan && computedLoan.principalBalance && isFinite(computedLoan.principalBalance)) {
    //         loanAmount = loanAmount + computedLoan.principalBalance;
    //       }
    //     });
    //   }
    //   this.loanBalance = JSON.parse(JSON.stringify(loanAmount));
    //   this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
    // });

    // this.myHomeState.activeHomeValues$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((response) => {
    //   if (response && response.length && this.activeHome && this.activeHome.PMXPropertyId) {
    //     this.propertyValuesChanged();
    //   }
    // });
    // this.myHomeState.openSpendForecastSheet$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((status) => {
    //   this.spendForecastSheetActive = status;
    // });

    // Subscribe to URL Query Params and trigger Add Property if address components exists
    // this.activatedRoute.queryParams.pipe(takeUntil(this.onDestroyNotifier)).subscribe((res) => {
    //   if (res && res.street && res.city && res.state && res.zip) this.openAppPropertyDialog(res);
    // });
  }

  ngOnChanges() {
    if (!this.address) this.address = {};
    this.spendForecastForm.controls.customCurrentValue.setValue(
      this.address.customCurrentValue ? this.address.customCurrentValue : this.currentValue,
      { emitEvent: false }
    );
    this.spendForecastForm.controls.customPropmixValue.setValue(
      this.address.customPropmixValue ? this.address.customPropmixValue : this.propmixValue,
      {
        emitEvent: false,
      }
    );
    this.spendForecastForm.controls.customPurchaseValue.setValue(
      this.address.customPurchaseValue
        ? this.address.customPurchaseValue
        : this.purchaseValue
          ? this.purchaseValue
          : null,
      {
        emitEvent: false,
      }
    );

    this.myHomeState.DealAnalysisHome$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && Object.keys(res).length !== 0) {
        this.purchaseValue = res.customPurchaseValue;
        this.spendForecastForm.controls.customPurchaseValue.setValue(res.customPurchaseValue);
      }
    });

    // if (this.address) {
    //   this.defaultPlace = this.address.coordinate ? this.address.coordinate : {};
    //   this.showMap();
    // }
  }

  revertValue(event) {
    let propertyValues = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.address.PMXPropertyId
    );
    if (event == 'customCurrentValue') {
      this.spendForecastForm.controls.customCurrentValue.setValue(propertyValues.currentValue, { emitEvent: false });
    } else if (event == 'customPropmixValue') {
      this.spendForecastForm.controls.customPropmixValue.setValue(propertyValues.propmixValue, { emitEvent: false });
    } else if (event == 'customPurchaseValue') {
      this.spendForecastForm.controls.customPurchaseValue.setValue(this.purchaseValue);
      // this.spendForecastForm.controls.customPurchaseValue.setValue(this.myHomeState.activeHomeValue.purchaseValue, {
      //   emitEvent: false,
      // });
    }
  }

  saveValue(event) {


    if (event == 'customPurchaseValue' && !this.isEquityAnalysis) {
      this.saveEdited(event);
      // this.purchaseValueEvent.emit(this.spendForecastForm.controls.customPurchaseValue.value);
      this.purchaseValuePopover.close();
      this.logUserActivity(
        constants.LOGGER.myHome.category,
        constants.LOGGER.myHome.action.purchasePriceUpdate.key,
        this.pmxPropertyId,
        this.loggerAddress
      );
    } else {
      const customPurchaseValue = this.spendForecastForm.get('customPurchaseValue')?.value;
      const customPurchaseData = {
        customPurchaseValue: customPurchaseValue
      }
      this.myHomeState.customEquityData = customPurchaseData
      this.purchaseValuePopover.close();

    }
  }

  logUserActivity(category, action, PMXPropertyId, address) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = { PMXPropertyId: PMXPropertyId, address: address };
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }

  saveEdited(event) {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    if (event == 'customPurchaseValue') {
      (this.myHomeState.DealAnalysisHomeValue = {
        ...this.myHomeState.DealAnalysisHomeValue,
        customPurchaseValue: this.spendForecastForm.value.customPurchaseValue,
      }),
        (this.purchaseValue = this.spendForecastForm.value.customPurchaseValue);
      myHomeValues.customPurchaseValue = this.spendForecastForm.controls.customPurchaseValue.value?.toFixed() || 0;
    }

    this.myHomeService
      .updateMyHomeValues([myHomeValues], false)
      .pipe()
      .subscribe((res: any) => { });
  }

  isNegativeOrder(value: number): boolean {
    return value < 0;
  }

  onSectionScrolled(event: Event) {
    this.mortgageSectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
  equitySectionScrolled(event: Event) {
    this.equitySectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  currentValueEdited(value) {
    if (!this.propmixValue) this.netEquity = Number(value) - this.loanBalance;
  }

  propmixValueEdited(value) {
    this.netEquity = Number(value) - this.loanBalance;
    this.appreciateRatio =
      Number(value) && Number(this.purchaseValue)
        ? ((Number(value) - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
  }

  purchaseValueEdited(value) {
    this.appreciateRatio =
      Number(this.propmixValue) && Number(this.purchaseValue)
        ? ((this.propmixValue - Number(value)) / Number(value)) * 100
        : 0;
  }

  propertyValuesChanged() {
    let propertyValues = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.activeHome.PMXPropertyId
    );
    this.propmixValue =
      this.activeHome && Number(this.activeHome.customPropmixValue)
        ? this.activeHome.customPropmixValue
        : propertyValues && propertyValues.propmixValue
          ? propertyValues.propmixValue
          : 0;
    this.currentValue =
      this.activeHome && Number(this.activeHome.customCurrentValue)
        ? this.activeHome.customCurrentValue
        : propertyValues && propertyValues.currentValue
          ? propertyValues.currentValue
          : 0;
    this.purchaseValue =
      this.activeHome && Number(this.activeHome.customPurchaseValue)
        ? this.activeHome.customPurchaseValue
        : this.activeHome && this.activeHome.purchaseValue
          ? this.activeHome.purchaseValue
          : 0;
    this.appreciateRatio =
      this.propmixValue && this.purchaseValue
        ? ((this.propmixValue - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
    this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
  }

  addressComponents(response) {
    this.myHomeState.activePropertyDetails$.subscribe((res) => {
      if (res?.basic) {
        this.activePropertyDetails = res.basic;
        let propertyInfo = {
          streetAddress: this.activePropertyDetails.StreetAddress,
          fullAddress: this.activePropertyDetails.Address,
          city: this.activePropertyDetails.City,
          state: this.activePropertyDetails.StateOrProvince,
          zip: this.activePropertyDetails.PostalCode,
          propertySubType: this.activePropertyDetails.PropertySubType,
          bedCount: this.activePropertyDetails.BedroomsTotal,
          bathCount: this.activePropertyDetails.BathroomsTotalInteger,
          livingAreaSize: this.activePropertyDetails.LivingArea,
          lotSize: this.activePropertyDetails.LotSizeSquareFeet,
          coordinate: response.coordinate,
          PMXPropertyId: this.activePropertyDetails.PMXPropertyId,
          id: response.id,
          streetName: this.activePropertyDetails.StreetName,
          streetNumber: this.activePropertyDetails.StreetNumber,
          propertyType: this.activePropertyDetails.PropertyType,
          purchaseDate: response.purchaseDate,
          customCurrentValue: response.customCurrentValue,
          customPropmixValue: response.customPropmixValue,
          customPurchaseValue: response.customPurchaseValue,
          lstListingId: this.activePropertyDetails.Lst_ListingId,
        };
        this.address = propertyInfo;
      }
    });
  }

  getPropertyValues() {
    this.myHomeState.activeHomePropertyLoaderValue = true;
    let isValueExists = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.activeHome.PMXPropertyId
    );
    if (!isValueExists) {
      let params = {
        StreetNumber: this.activeHome.streetNumber,
        StreetName: this.activeHome.streetName,
        City: this.activeHome.city,
        State: this.activeHome.state,
        Zip: this.activeHome.zip,
        pmxPropertyId: this.activeHome.PMXPropertyId,
      };
      this.myHomeService.getPropertyValues(params).subscribe(() => { });
    } else {
      this.propertyValuesChanged();
      this.myHomeState.activeHomePropertyLoaderValue = false;
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next();
    this.onDestroyNotifier.complete();
    this.myHomeState.mortgageListValue = [];
    this.myHomeState.activeHomeValue = {};
    this.myHomeState.activePropertyDetailsValue = null;
  }

  getHomeList() {
    // if (!this.myHomeState.myHomeListValue || !this.myHomeState.myHomeListValue.length) {
    this.myHomeService
      .getHomeList()
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(({ isLoading }) => {
        this.isLoading = isLoading;
      });
    // }
  }

  updateHome() {
    this.myHomeService
      .updateMyHomeValues(this.myHomeState.myHomeListValue)
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((res) => { });
  }

  openAppPropertyDialog(addressComponent: any) {
    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.addMyHome.key)) return;

    this.dialog.open(CreateMyHomeDialogueComponent, {
      width: '385px',
      disableClose: true,
      data: addressComponent,
    });
  }

  closeSpendForecastSheet() {
    this.myHomeState.openSpendForecastSheetValue = false;
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    if (
      !/^[0-9]$/.test(event.key) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      event.key !== 'Home' &&
      event.key !== 'End'
    ) {
      event.preventDefault();
    }
  }

  deleteProperty(id) {
    let _this = this;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteMyHomeProperty',
        message: 'The selected property will be deleted from My Properties',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          if (status) {
            _this.selectedPmxId = null;
            _this.myHomeService.deleteMyHomeProperty(id).subscribe((res: any) => {
              callBack({ status: true });
              dialogRef.close();
            });
          } else {
            return false;
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });
  }
  openMortgagePopup(data?) {
    this.dialog.open(CreateMortgageDialogComponent, {
      width: '385px',
      disableClose: true,
      data: {
        type: data && data.type ? data.type : 'addMortgage',
        title: data && data.title ? data.title : 'Add Mortgage',
        message: data && data.message ? data.message : 'Add missing mortgage to current property!',
        principal: data && data.principal ? data.principal : null,
        interest: data && data.interest ? data.interest : '',
        term: data && data.term ? data.term : '',
        startDate: data && data.startDate ? data.startDate : '',
        id: data && data.id ? data.id : null,
      },
    });
  }
}
